import * as React from "react";
import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio";

/**
 * Aspect Ratio Component
 *
 * A component that maintains a consistent width/height ratio.
 * Useful for responsive images, videos, and other media content.
 *
 * @example
 * ```tsx
 * <AspectRatio ratio={16 / 9}>
 *   <img src="/image.jpg" alt="Description" />
 * </AspectRatio>
 * ```
 */
function AspectRatio({ ...props }: React.ComponentProps<typeof AspectRatioPrimitive.Root>) {
    return <AspectRatioPrimitive.Root data-slot="aspect-ratio" {...props} />;
}

AspectRatio.displayName = "AspectRatio";

export { AspectRatio };
